import { DefaultBaseObjectFormGroupMapper } from './default-base-object-form-group.mapper';
import { BaseObject } from '../_models/base-object';
import { Mixer } from '../_models/_unit-operations/mixer';
import { hasNumericValue } from '../_utils/utils';
import { MixerBlendRecipeOption } from '../_config/unit-operations/mixer-enums';

export class MixerFormGroupMapper extends DefaultBaseObjectFormGroupMapper {
  override map(source: BaseObject, destination: BaseObject) {
    super.map(source, destination);

    // not really mixer though...
    const sourcePlainObject = source as Mixer;
    const destinationInstance = destination as Mixer;

    this.mapMixingRatioVariables(sourcePlainObject, destinationInstance);
    this.mapConstraintValues(destinationInstance);
  }

  private mapMixingRatioVariables(sourcePlainObject: Mixer, destinationInstance: Mixer) {
    if (sourcePlainObject.mixingRatioVariables) {
      // TODO not sure about this check
      if (sourcePlainObject.mixingRatioVariables.length !== destinationInstance.mixingRatioVariables.length) {
        throw new Error(
          `Source and destination number of Mixing Ratio variables don't match` +
            `${sourcePlainObject.name} - ${destinationInstance.mixingRatioVariables}`
        );
      }

      for (let i = 0; i < sourcePlainObject.mixingRatioVariables.length; i++) {
        if (hasNumericValue(sourcePlainObject.mixingRatioVariables[i].value)) {
          destinationInstance.mixingRatioVariables[i].value = +sourcePlainObject.mixingRatioVariables[i].value;
        } else {
          destinationInstance.mixingRatioVariables[i].value = undefined;
        }

        if (hasNumericValue(sourcePlainObject.mixingRatioVariables[i].minimumValue)) {
          destinationInstance.mixingRatioVariables[i].minimumValue =
            +sourcePlainObject.mixingRatioVariables[i].minimumValue;
        } else {
          destinationInstance.mixingRatioVariables[i].minimumValue = undefined;
        }

        if (hasNumericValue(sourcePlainObject.mixingRatioVariables[i].maximumValue)) {
          destinationInstance.mixingRatioVariables[i].maximumValue =
            +sourcePlainObject.mixingRatioVariables[i].maximumValue;
        } else {
          destinationInstance.mixingRatioVariables[i].maximumValue = undefined;
        }
      }
    }
  }

  mapConstraintValues(destinationInstance: Mixer) {
    let constraintsLength = Object.keys(destinationInstance.constraints.constraints).length;
    if (constraintsLength > 0) {
      Object.values(destinationInstance.constraints.constraints).forEach(cstr => {
        const mixingRatioVariable = destinationInstance.findMixingRatioVariable(cstr.sourceUnitOperationId);

        switch (destinationInstance.blendRecipeOption) {
          case MixerBlendRecipeOption.EXACT:
            if (cstr.constraintName.includes('Minimum') || cstr.constraintName.includes('Maximum')) {
              delete destinationInstance.constraints.constraints[cstr.id];
            } else {
              cstr.constraintValue = mixingRatioVariable.value;
            }
            break;
          case MixerBlendRecipeOption.RANGE:
            if (cstr.constraintName.includes('Minimum')) {
              cstr.constraintValue = mixingRatioVariable.minimumValue;
            } else if (cstr.constraintName.includes('Maximum')) {
              cstr.constraintValue = mixingRatioVariable.maximumValue;
            } else {
              delete destinationInstance.constraints.constraints[cstr.id];
            }
            break;
          default:
            throw new Error('Unknown Blend Recipe Option');
        }
      });
      constraintsLength = Object.values(destinationInstance.constraints.constraints).length;
    }

    if (constraintsLength === 0) {
      destinationInstance.mixingRatioVariables.forEach(mixRatioVar => {
        destinationInstance.initConstraintsBasedInMixingRatios(mixRatioVar);
      });
    }
  }

  override ignoreForAutoMapping(key: string, source: BaseObject, destination: BaseObject): boolean {
    const sourcePlainObject = source as Mixer;
    return (
      super.ignoreForAutoMapping(key, source, destination) || source[key] === sourcePlainObject.mixingRatioVariables
    );
  }
}
